import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.keys.js";
import { extend } from 'indicative/validator';
import { getValue, skippable } from 'indicative-utils';
import { validateCompanyIdent } from '~/utils/string';
var validables = {};
export default (function (_ref, inject) {
  var app = _ref.app;
  var $cbValidator = {
    init: function init() {
      validables = {};
    },
    addValidable: function addValidable(key, validator) {
      validables[key] = validator;
    },
    removeValidable: function removeValidable(key) {
      delete validables[key];
    },
    validate: function validate() {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var keys, index, key, validator;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              keys = Object.keys(validables);
              index = 0;
            case 1:
              if (!(index < keys.length)) {
                _context.next = 4;
                break;
              }
              key = keys[index];
              validator = validables[key];
              _context.next = 2;
              return validator();
            case 2:
              if (_context.sent) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", false);
            case 3:
              index++;
              _context.next = 1;
              break;
            case 4:
              return _context.abrupt("return", true);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  };
  inject('cbValidator', $cbValidator);
});

/**
 * Extend indicative validator
*/

// Simple validator which returns true everytime.
// Used as fallback validator for optional fields as
// they should pass all the time.
extend('valid', {
  validate: function validate() {
    return true;
  }
});

// Checks if the strings is
// valid Finnish/Swedish company ident
extend('companyIdent', {
  validate: function validate(data, field, args, config) {
    var fieldValue = getValue(data, field);
    if (skippable(fieldValue, field, config)) {
      return true;
    }
    return validateCompanyIdent(fieldValue);
  }
});